// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingAddressStyles } from "@guestsupply/Overrides/Widgets/CheckoutShipping/ShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

shippingAddressStyles.container = { gap: 12 };
shippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: center;
    `,
};
shippingAddressStyles.headingText = {
    variant: "h6",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};
shippingAddressStyles.selectSavedAddressLink = {
    typographyProps: {
        size: 12,
    },
    css: css`
        margin-left: 20px;
    `,
};
shippingAddressStyles.addressBookModal = { sizeVariant: "medium" };
shippingAddressStyles.addressBookModalButtonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 1rem;
    `,
};
shippingAddressStyles.addressBookModalCancelButton = { variant: "secondary" };
shippingAddressStyles.oneTimeAddressGridItem = { width: 12 };
shippingAddressStyles.addressDisplayAndFormGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

shippingAddressStyles.useBillingAddressButton = {
    variant: "secondary",
    css: css`
        margin-top: 20px;
    `,
};
shippingAddressStyles.headingWrapper = {
    css: css`
        display: flex;
        width: 100%;
        padding-bottom: 8px;
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};
